import React, { useRef } from "react";
import { toKebabCase } from "@qlik/qlik/src/lib/utils";
import LevelThreeMenu from "@qlik/qlik/src/components/Header/Dropdowns/Submenu_Level_Three";
import * as styles from "./styles.module.css";
import Link from "@qlik/qlik/src/components/Link";
import { createParameterizedUrl, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { LAYOUT_LINK_ONLY } from "@qlik/qlik/src/lib/constants/menu-layout-names";

/**
 * See <Header> component's doc comment
 */
const SubmenuLevelThreeWhyQlik = ({ data, activeMenu, setHasSubItems }) => {
    const { id, subItems } = data ?? {};
    const submenuWhyQlikRefs = useRef([]);
    let submenuOneSelectedChild;

    // 1st level menu expanding event handler
    const handleSubmenuMouseEnter = (index, itemName) => {
        const hoveredMenuItem = submenuWhyQlikRefs.current[index];

        // Level two submenu hover and active classes
        submenuWhyQlikRefs.current.forEach((element) => {
            element?.classList.remove("active");
        });
        hoveredMenuItem?.classList.add("active");

        // Level three submenu hover and active classes
        const submenuLevelThreeElms = document.querySelectorAll(`.submenu-level-3`);
        submenuLevelThreeElms.forEach((menuItem) => {
            menuItem?.classList.remove("active");
        });

        submenuOneSelectedChild = submenuWhyQlikRefs.current[index].attributes.rel.value;
        const submenuWhyQlikItem = document.querySelector(
            `.submenu-level-3[data-parent="${submenuOneSelectedChild}"][data-device="desktop"]`
        );
        submenuWhyQlikItem?.classList.add("active");

        // If this is the layout for the active element, then set subItems to false
        setHasSubItems(itemName !== LAYOUT_LINK_ONLY);
    };

    return (
        <div
            id={id}
            className={`submenu relative submenu--${activeMenu} max-xl:flex-col h-screen xl:h-auto gap-x-15 xl:before:absolute xl:before:content-[''] xl:before:h-full xl:before:-mr-3.75 xl:before:w-screen xl:before:right-full xl:before:top-0 xl:before:bg-stone-light ${
                activeMenu === id ? "submenu-active" : ""
            } `}
        >
            <div className="submenu-level-2-wrapper xl:flex-300">
                <ul className="flex flex-col xl:h-full gap-y-2.5 xl:py-10 xl:bg-stone-light">
                    {subItems?.map((subItem, index) => {
                        const itemName = toKebabCase(subItem.itemName);
                        const activeClass = submenuOneSelectedChild === itemName ? "active" : "";
                        let pageUrl = createParameterizedUrl(subItem);
                        return (
                            <li
                                key={subItem.id}
                                className={`subMenuItem ${activeClass}`}
                                ref={(el) => {
                                    if (el !== null) {
                                        submenuWhyQlikRefs.current[index] = el;
                                    }
                                }}
                                // eslint-disable-next-line react/no-invalid-html-attribute
                                rel={`${itemName}-${index}`}
                                onMouseEnter={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleSubmenuMouseEnter(index, subItem.itemName);
                                }}
                            >
                                <Link to={pageUrl} className="relative flex flex-col xl:py-5">
                                    <span
                                        className="font-semibold title-5 text-gray"
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{
                                            __html: renderSanitizedHtmlContent(subItem.title),
                                        }}
                                    />
                                    {subItem.description && (
                                        <span
                                            className="mt-2.5 text-xs text-gray leading-tight xl:text-sm"
                                            dangerouslySetInnerHTML={{
                                                __html: renderSanitizedHtmlContent(subItem.description),
                                            }}
                                        />
                                    )}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className="submenu-level-3-wrapper xl:flex-810">
                {subItems?.map((subItem, index) => (
                    <LevelThreeMenu data={subItem} key={subItem.id} layoutId={index} />
                ))}
            </div>
        </div>
    );
};
export default SubmenuLevelThreeWhyQlik;
